import { useState } from 'react';
import ImagePreviewModal from '@/routes/TenantLayout/SkillManagement/shared/ImagePreviewModal';
import { useAttachmentUrl } from '../api/useAttachmentUrl';

interface AttachmentImageProps {
  storagePath: string;
  alt?: string;
  maxWidth?: number;
}

export function AttachmentImage({
  storagePath,
  alt = 'attachment',
  maxWidth = 320,
}: AttachmentImageProps) {
  const { url, loading } = useAttachmentUrl(storagePath);
  const [open, setOpen] = useState(false);

  if (loading || !url) {
    return (
      <div
        style={{
          width: maxWidth,
          height: maxWidth * 0.6,
          background: '#f0f0f0',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#999',
          fontSize: 12,
        }}
      >
        {loading ? 'Loading…' : 'Image unavailable'}
      </div>
    );
  }

  return (
    <>
      <img
        src={url}
        alt={alt}
        onClick={() => setOpen(true)}
        style={{
          maxWidth,
          maxHeight: maxWidth,
          borderRadius: 8,
          display: 'block',
          cursor: 'pointer',
        }}
      />
      <ImagePreviewModal
        isOpen={open}
        imageUrl={url}
        onClose={() => setOpen(false)}
        title={alt}
      />
    </>
  );
}
